<template>
<div class="s4s-page">
  <div class="s4s-user">
    <div class="s4s-user-header">
      {{userInfo&& (userInfo.Nick || userInfo.Name || userInfo.Tel)}} 车主用户您好。
    </div>
    <div class="s4s-user-body">
      <div class="s4s-group" @click="gotoCarlist">
        <span class="s4s-group-tit" style="color:#24252d;">我的爱车</span>
        <div class="s4s-group-txt s4s-user-btn">管理我的爱车
          <img src="../assets/icon/right_arr.png" class="s4s-right-arr"/>
        </div>
      </div>
      <div v-if="advertisingShow.channel !== 'cmbapp'" class="s4s-group" @click="gotoOrderList">
        <span class="s4s-group-tit" style="color:#24252d;">我的订单</span>
        <div class="s4s-group-txt s4s-user-btn">当前处理中订单
          <span style="color:#3a82ff;padding:0 5px;"> {{staticData.HandleSum || 0}} </span> 条
          <img src="../assets/icon/right_arr.png"
            mode="aspectFit" class="s4s-right-arr"/>
        </div>
      </div>
    </div>
  </div>
  <div class="s4s-copyright" style="margin-top:15px;">
    <div>本服务由<span @click="gotoMys4s" class="blue">齐车大圣</span>提供，客服电话：
      <a class="s4s-copyright-phone" href="tel://0571-26281166" >0571-26281166</a>
    </div>
  </div>
  <div class='s4s-ad-header' v-if="moreList&&moreList.length&&!advertisingShow">
    <div class='s4s-ad-line'></div>
    <div class='s4s-ad-header-content'>更多服务</div>
    <div class='s4s-ad-line'></div>
  </div>
  <div class='s4s-more' moreList v-if="!advertisingShow">
    <div class='s4s-more-list'>
      <div
        v-for="item in moreList"
        :key="item.name"
        class='s4s-more-item'
        @click="gotoMini(item)"
        >
        <img :src="item.icon" mode='aspectFit' class='s4s-more-image' />
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import advertisingShow from './../utils/advertising';

export default {
  name: 'user',
  data() {
    return {
      // 需要挪至store
      staticData: {},
      moreList: [
        {
          name: '码上挪车',
          icon: 'https://app.s4s.cn/mini-icon/movecar.png',
          url: 'https://mys4s.cn/static/nc/h5/index.html',
        },
        // {
        //   name: '违章查询',
        //   icon: 'https://app.s4s.cn/mini-icon/vio.png',
        //   url: 'https://mys4s.cn/static/vio/index.html',
        // },
        // {
        //   name: '驾考题库',
        //   id: '2018011601916155',
        //   icon: carbook,
        //   url: 'https://mys4s.cn/h5/oil/index.html?source=uc'
        // },
        {
          name: '油价查询',
          icon: 'https://app.s4s.cn/mini-icon/oil.png',
          url: 'https://mys4s.cn/h5/oil/index.html?source=h5_vio',
        },
        {
          name: '限行指南',
          icon: 'https://app.s4s.cn/mini-icon/guide.png',
          url: 'https://mys4s.cn/v5/carlimit/index',
        },
        {
          name: '更多服务',
          icon: 'https://app.s4s.cn/mini-icon/more.png',
          url: 'https://mys4s.cn/#/driver?current=5',
        },
      ],
      advertisingShow: advertisingShow(),
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '0', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '个人中心'
      });
    }
    if(!this.checkLogin()) return
    
    // 需要挪至store
    this.getOrderStatic();
  },
  methods: {
    gotoMini(item) {
      
      // _czc.push(['_trackEvent', 'user', 'more', item.name + '','打开app','']); //eslint-disable-line
      window.location.href = item.url;
    },
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', 'user','','']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    // 我的爱车
    gotoCarlist() {
      this.$router.push({
        name: 'carList',
      });
    },
    // 订单列表
    gotoOrderList() {
      this.$router.push({
        name: 'order',
      });
    },
    // 获取订单状态
    getOrderStatic() {
      this.$request('v3/violation/order/static').then((xhr, res) => {
        if (res.code === 0) {
          this.staticData = res.data;
        }
      });
    },
    checkLogin(){
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.replace({
          path: '/login',
          query: {
            redirect: '/user',
          },
        });
        console.log('checkLogin')
        return false;
      }else{
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.s4s-page {
  background-image:url(../assets/icon/bg_user.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.s4s-user {
  /* background-image: linear-gradient(-90deg, #3A82FF 10%, #115FF8 100%); */
  border-radius: 2px;
  font-size: 14px;
}
.s4s-user-header {
  text-align: center;
  color: #fff;
  padding: 26px 0 25px;
  font-size: 18px;
}
.s4s-user-body {
  padding:  0 15px;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  background-color: #fff;
  border-radius: 2px;
}

.s4s-more {
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 2px;
  margin-top:10px;
}

.s4s-more-title {
  color:#24252d;
  padding:10px 0 15px;
  border-bottom: .5px solid #eaeaea;
}

.s4s-more-list {
  min-height: 6px;

}

.s4s-right-arr {
  height: 14px;
  width: 7px;
  margin-left: 10.5px;
}
.s4s-user-btn {
  color:#9c9ea8;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}


.s4s-more {
  color:#24252d;
  padding: 20px 0;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 2px;
  margin-top: 10px;
  font-size: 13px;
  line-height: 18px;
}

.s4s-more-title {
  color:#24252d;
  padding: 10px 0 15px;
  font-size: 15px;
  border-bottom: 1px solid #eaeaea;
}

.s4s-more-list {
  display: flex;
}

.s4s-more-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.s4s-more-image {
  width: 40px!important;
  height: 40px!important;
  margin-bottom: 7px;
  border-radius: 20px;
}

.s4s-more-item:first-child  .s4s-more-image {
  box-shadow: 0 3px 5px 0 rgba(29,138,222,0.15);
}
.s4s-more-item:nth-child(2)  .s4s-more-image {
  box-shadow: 0 3px 5px 0 rgba(39,45,206,0.15);
}
.s4s-more-item:nth-child(3) .s4s-more-image {
  box-shadow: 0 3px 5px 0 rgba(27,161,103,0.15);
}
.s4s-more-item:last-child  .s4s-more-image {
  box-shadow: 0 3px 5px 0 rgba(212,134,12,0.15);
}

</style>

